import createIcon from '../../createIcon';

/**
 * @component @name TextRotationDown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTJWMTAuNUwxMCA1Ljc1VjcuODVMMTIuMiA4Ljc1VjEzLjc1TDEwIDE0LjY1VjE2Ljc1TDIxIDEyWk0xNCA5LjM4TDE5LjAyIDExLjI1TDE0IDEzLjEyVjkuMzhaTTYgMTkuNzVMOSAxNi43NUg3VjQuMjVINVYxNi43NUgzTDYgMTkuNzVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TextRotationDown = createIcon('TextRotationDown', [
  [
    'path',
    {
      d: 'M21 12V10.5L10 5.75V7.85L12.2 8.75V13.75L10 14.65V16.75L21 12ZM14 9.38L19.02 11.25L14 13.12V9.38ZM6 19.75L9 16.75H7V4.25H5V16.75H3L6 19.75Z',
      key: 'sycz8r',
    },
  ],
]);

export default TextRotationDown;
